var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginMetamask(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3046 5.37524L17.9399 12.3305L19.6717 8.22701L27.3046 5.37524Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.68591 5.37524L14.9753 12.3964L13.3283 8.22701L5.68591 5.37524Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9353 21.4976L21.4412 25.3187L26.7776 26.787L28.3117 21.5823L23.9353 21.4976Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69763 21.5823L6.22234 26.787L11.5588 25.3187L9.06469 21.4976L4.69763 21.5823Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2577 15.0412L9.77063 17.2906L15.0695 17.5259L14.8812 11.8318L11.2577 15.0412Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.733 15.0412L18.0624 11.7659L17.9401 17.5259L23.2295 17.2906L21.733 15.0412Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5588 25.3187L14.74 23.7658L11.9918 21.6199L11.5588 25.3187Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2506 23.7658L21.4412 25.3187L20.9988 21.6199L18.2506 23.7658Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4412 25.3188L18.2506 23.7659L18.5047 25.8459L18.4765 26.7212L21.4412 25.3188Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5588 25.3188L14.5235 26.7212L14.5047 25.8459L14.74 23.7659L11.5588 25.3188Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5706 20.2458L11.9165 19.4646L13.7894 18.6082L14.5706 20.2458Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.42 20.2458L19.2012 18.6082L21.0836 19.4646L18.42 20.2458Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5588 25.3187L12.0106 21.4976L9.0647 21.5823L11.5588 25.3187Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9894 21.4976L21.4411 25.3187L23.9353 21.5823L20.9894 21.4976Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2295 17.2905L17.9401 17.5258L18.4295 20.2458L19.2107 18.6082L21.093 19.4646L23.2295 17.2905Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9165 19.4646L13.7989 18.6082L14.5706 20.2458L15.0695 17.5258L9.77063 17.2905L11.9165 19.4646Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77063 17.2905L11.9918 21.6199L11.9165 19.4646L9.77063 17.2905Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0929 19.4646L20.9988 21.6199L23.2294 17.2905L21.0929 19.4646Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0694 17.5259L14.5706 20.2459L15.1917 23.4553L15.3329 19.2294L15.0694 17.5259Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M17.94 17.5259L17.6859 19.22L17.7989 23.4553L18.4294 20.2459L17.94 17.5259Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4294 20.2458L17.7988 23.4552L18.2506 23.7658L20.9988 21.6199L21.0929 19.4646L18.4294 20.2458Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9165 19.4646L11.9918 21.6199L14.74 23.7658L15.1918 23.4552L14.5706 20.2458L11.9165 19.4646Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4765 26.7212L18.5047 25.8459L18.2694 25.6388H14.7212L14.5047 25.8459L14.5235 26.7212L11.5588 25.3188L12.5941 26.1659L14.693 27.6247H18.2977L20.4059 26.1659L21.4412 25.3188L18.4765 26.7212Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2505 23.7659L17.7988 23.4553H15.1917L14.7399 23.7659L14.5046 25.8459L14.7211 25.6389H18.2693L18.5046 25.8459L18.2505 23.7659Z",
    fill: "#161616",
    stroke: "#161616",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7 12.7823L28.5 8.9423L27.3047 5.37524L18.2506 12.0952L21.733 15.0411L26.6553 16.4811L27.7471 15.2105L27.2765 14.8717L28.0294 14.1847L27.4459 13.7329L28.1988 13.1588L27.7 12.7823Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 8.9423L5.3 12.7823L4.79176 13.1588L5.54471 13.7329L4.97059 14.1847L5.72353 14.8717L5.25294 15.2105L6.33529 16.4811L11.2576 15.0411L14.74 12.0952L5.68588 5.37524L4.5 8.9423Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6553 16.481L21.7329 15.041L23.2294 17.2904L20.9988 21.6198L23.9352 21.5822H28.3117L26.6553 16.481Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2576 15.041L6.33528 16.481L4.69763 21.5822H9.06469L11.9917 21.6198L9.77057 17.2904L11.2576 15.041Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M17.94 17.5259L18.2506 12.0953L19.6812 8.22705H13.3282L14.74 12.0953L15.0694 17.5259L15.1824 19.2388L15.1918 23.4553H17.7988L17.8177 19.2388L17.94 17.5259Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginMetamask);
export default __webpack_public_path__ + "static/media/login-metamask.cfda4e3741e6495cdef2d4376fb008b7.svg";
export { ForwardRef as ReactComponent };